<template>
  <button :class="`p-4 text-base font-medium ${classList}`" @click="$router.go(-1)">
    {{ $translations.shared.buttons.back }}
  </button>
</template>

<script>
  export default {
    name: 'BackButton',
    components: {},
    props: {
      classList: {
        type: String,
        default: ''
      }
    }
  };
</script>